import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { DivGeneral } from "./consultaBilletera";
import RetiroDinero from "./retiroDinero";
import IngresoDinero from "./ingresoDinero";
import styled from "styled-components";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  DivColRetiro,
  DivRow,
} from "../tools/identificadorQRCliente/PaginaSolicitudRetiro";
import { estilosProvNew } from "../configProvinciasNew";
import $ from "jquery";
import "jquery-confirm";

const IdentificadorQRCliente = ({
  estadoPlataforma,
  mensajeErrorWS,
  mensajeErrorGeneral,
  cerrarSesion,
  logCurrentPage,
  handlePendingNavigatePage,
  lanzarModalCuil,
  volverAPlataforma,
  altaCuilCliente,
  traerMisDatosPersonales,
}) => {
  const { ingresoretiro } = useParams();
  const history = useHistory();

  const [active, setactive] = useState(0);
  const [cambioAgencia, setCambioAgencia] = useState(false);
  const color = process.env.REACT_APP_MANIFEST_COLOR;
  const colorNew =
    estilosProvNew[process.env.REACT_APP_COD_ORGANIZACION].secondary;

  useEffect(() => {
    logCurrentPage("retirar");
    fetchCambioAgencia();
  }, []);

  const fetchCambioAgencia = () => {
    const url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_MIS_DATOS_PERSONALES;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${estadoPlataforma.userToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "ok") {
          setCambioAgencia(data.cambioAgencia?.agencia?.codigo != null);
        } else {
          $.alert({
            title: "Error",
            content: "Error al consultar datos personales.",
            type: "red",
            buttons: {
              ok: {
                text: "Aceptar",
                btnClass: "btn-red",
              },
            },
          });
        }
      })
      .catch(() => {
        mensajeErrorGeneral();
      });
  };

  const handleRetirarDineroClick = () => {
    if (!cambioAgencia) {
      setactive(1);
    } else {
      // console.log(cambioAgencia)
      $.alert({
        title: "Cambio de agencia programado",
        content: "Usted tiene un cambio de agencia programado. No puede realizar retiros hasta tanto se efectivice el cambio.",
        type: "red",
        buttons: {
          continuar: function () {},
        },
      });
    }
  };

  return (
    <DivGeneral className="pageFlow ">
      <DivRow className="row justify-content-center">
        <DivColRetiro className="col-12">
          <h3>
            <span
              className="iconify"
              data-icon="fluent:wallet-credit-card-28-filled"
              data-inline="false"
              data-width="60px"
              color={
                ["10", "40", "16", "46", "15", "45"].includes(process.env.REACT_APP_COD_ORGANIZACION)
                  ? colorNew
                  : color
              }
            />
          </h3>
        </DivColRetiro>
      </DivRow>
      <div className="row justify-content-center text-center">
        <h3>
          <div className="col-12 mt-4">
            <div>Billetera</div>
          </div>
        </h3>
      </div>
      <ul className="nav justify-content-center">
        {(["20", "50", "23", "53", "12", "42"].includes(process.env.REACT_APP_COD_ORGANIZACION) || estadoPlataforma.apellido === "MAN-815") && (
          <li className="nav-item">
            <Link to="/identificadorQRCliente/0">
              <BotonTab
                color={color}
                active={ingresoretiro == 0}
                onClick={() => setactive(0)}
                className="nav-link"
                aria-current="page"
              >
                Ingresar Dinero
              </BotonTab>
            </Link>
          </li>
        )}

        <li className="nav-item">
          <Link to="/identificadorQRCliente/1">
            <BotonTab
              color={color}
              active={ingresoretiro == 1 && !cambioAgencia}
              className="nav-link"
              onClick={handleRetirarDineroClick}
            >
              Retirar Dinero
            </BotonTab>
          </Link>
        </li>
      </ul>
      {ingresoretiro == 0 ? (
        <IngresoDinero
          estadoPlataforma={estadoPlataforma}
          mensajeErrorWS={mensajeErrorWS}
          mensajeErrorGeneral={mensajeErrorGeneral}
          cerrarSesion={cerrarSesion}
          history={history}
          logCurrentPage={logCurrentPage}
          volverAPlataforma={volverAPlataforma}
          lanzarModalCuil={lanzarModalCuil}
        />
      ) : (
        !cambioAgencia && (
          <RetiroDinero
            estadoPlataforma={estadoPlataforma}
            mensajeErrorWS={mensajeErrorWS}
            mensajeErrorGeneral={mensajeErrorGeneral}
            cerrarSesion={cerrarSesion}
            history={history}
            logCurrentPage={logCurrentPage}
            volverAPlataforma={volverAPlataforma}
            lanzarModalCuil={lanzarModalCuil}
          />
        )
      )}
    </DivGeneral>
  );
};

export default IdentificadorQRCliente;

const BotonTab = styled.button`
  border: none;
  border-bottom: solid;
  ${(props) =>
    props.active
      ? "border-bottom-color:" + props.color + ";"
      : "border-bottom-color: transparent"};

  background-color: transparent;

  &:hover {
    background-color: #ebebeb;
  }
`;
